export const addPXSuffix = string => {
  if (!string) return ''
  if (isNaN(string)) return string //if string is not a number
  return `${string}px`
}

export const addImportant = string => `${string} !important`

export const noop = () => {}
